import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { DBDef_LogTemplate } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onLogTemplatesUpdated = new ThunderDispatcherV3('__onLogTemplatesUpdated');
export class ModuleFE_LogTemplate_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_LogTemplate, dispatch_onLogTemplatesUpdated);
        this._v1 = {};
    }
    // ######################## Search ########################
    __searchFilterMapper = (item) => [item.label, item._id];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey,
                results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label,
                }))
            }];
    };
}
export const ModuleFE_LogTemplate = new ModuleFE_LogTemplate_Class();
//# sourceMappingURL=ModuleFE_LogTemplate.js.map